module.exports = __webpack_public_path__ + "img/alarm_add.b8571f71.svg";